<template>
  <div
    class="venueAppointment-content-item"
    v-show="isCurrentContentItem"
    v-bitmap="getListResult"
  >
    <venueAppointmentList
      :venueAppointmentList="venueAppointmentList"
      class="venueAppointment-list-content-main"
      :venueAppointmentStatus="currentStatus"
      @revocation="getvenueAppointmentList"
      @delClick="delClick"
      @edit="getvenueAppointmentList"
      @multipleDelete="multipleDelete"
    />
    <pagination
      :pageSize="pageSize"
      :total="total"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange=handleSizeChange
    ></pagination>
  </div>
</template>

<script>
import venueAppointmentList from "../venueAppointment-list/venueAppointment-list.vue";

export default {
  data() {
    return {
      total: 0,
      pageSize: 10,
      pageNum: 1,
      venueAppointmentList: null,
      getListResult: "nullData",
      testTotal: 1,
    };
  },
  components: {
    venueAppointmentList,
  },
  props: {
    isCurrentContentItem: {
      type: Boolean,
    },
    currentStatus: {
      type: Number,
      require: true,
    },
    changeStatus: {
      type: Number,
    },
    searchVenueNameContent: {
      type: String,
    },
    deleteList: {
      type: Array,
    },
  },
  watch: {
    // 切换列表显示
    isCurrentContentItem: {
      handler(val) {
        if (val && !this.venueAppointmentList) {
          this.getvenueAppointmentList();
          // console.log('切换1');
        }
      },
      immediate: true,
    },
    // 状态切换
    changeStatus: {
      handler(val) {
        if (val) {
          this.venueAppointmentList = null;
          if (this.isCurrentContentItem) {
            // console.log('切换2');
            this.getvenueAppointmentList();
          }
        }
      },
      immediate: true,
    },
    searchVenueNameContent() {
      // console.log("item==>", this.searchContent);
      this.venueAppointmentList = null;
      if (this.isCurrentContentItem) {
        this.getvenueAppointmentList();
      }
    },
    deleteList() {
      this.venueAppointmentList = null;
      if (this.isCurrentContentItem) {
        this.getvenueAppointmentList();
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 获取预约列表
    getvenueAppointmentList() {
      // console.log(this.searchContent);
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        schoolId: this.user.schoolId,
        teacherId: this.user.id,
        venueName: this.searchVenueNameContent,
        reviewStatus: this.currentStatus, // （0：待审核 1：通过 2：驳回 3：撤回
      };
      this.get(this.$url.getVenueappointmentList, data)
        .then((res) => {
          // console.log("查询场馆预约列表==>", res);
          this.venueAppointmentList = res.rows;
          if (res.code != 200) {
            this.getListResult = "error";
            this.$message.error("获取场馆预约列表失败！");
            return;
          }
          let data = res;
          this.total = data.total;
          this.venueAppointmentList = data.rows;
          this.total > 0
            ? (this.getListResult = "success")
            : (this.getListResult = "nullData");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    multipleDelete(list) {
      this.$emit("multipleDelete", list);
    },
    delClick(list) {
      // console.log(list);
      this.delete(this.$url.delVenueappointment + "/" + list)
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.$message.success("删除成功");
            // 刷新列表
            this.getvenueAppointmentList();
          }
        })
        .catch((err) => {
          // console.log(err);
          this.$message.error("删除失败，请稍后重试");
        });
    },
    // 分页
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getvenueAppointmentList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getvenueAppointmentList();
    },
    revocation(e) {
      this.$emit("revocation", e);
    },
    // 搜索
    // search(e) {
    //   // console.log(e);
    //   this.venueAppointmentList = null;
    //   if (e == "") {
    //     this.searchContent = "";
    //     this.getvenueAppointmentList();
    //   } else {
    //     this.searchContent = e;
    //     this.getvenueAppointmentList();
    //   }
    // },
  },
};
</script>

<style lang="sass" scoped>
@import "./venueAppointment-content-item.scss"
</style>